export function getImgSize(
  isFilled: boolean | undefined,
  isCatalogueIcon: boolean,
  isStoresIcon?: boolean
): string {
  if (isFilled) return '100%';

  if (isCatalogueIcon) return '26px';

  if (isStoresIcon) return '60px';

  return '50px';
}
